import clone from "clone";
import actions from "./actions";

const initState = {
  drivers: [],
  orders: [[], [], [], []],
  finishedOrders: [],
  finishedOrdersTotal: 0,
  finishedOrdersSummary: null,
  finishedOrdersDrivers: [],
  topCustomers: [],
  topCustomersTotal: 0,
  archiveLoading: false,
  modalOrder: {},
  showOrderInfoModal: false,
  showReadyOrders: false,
  deliveryEnabled: true,
  isLoading: false,
  organizationName: "",
  showNewOrderModal: false,
  menuItems: [],
  menuCategories: [],
  itemModifiers: {},
  customerHistory: null,
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.SET_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };

    case actions.GET_DELIVERY_ENABLED_SUCCESS:
      return {
        ...state,
        deliveryEnabled: action.deliveryEnabled,
        organizationName: action.organizationName,
      };

    case actions.TOGGLE_DELIVERY_ENABLED_SUCCESS:
      return {
        ...state,
        deliveryEnabled: action.newValue,
      };

    case actions.DELETE_ORDER_SUCCESS:
      state.orders[0] = state.orders[0].filter((u) => u.id !== action.orderId);
      return {
        ...state,
        orders: clone(state.orders),
      };

    case actions.TOGGLE_READY_ORDERS:
      return {
        ...state,
        showReadyOrders: !state.showReadyOrders,
      };

    case actions.GET_DRIVERS_SUCCESS:
      return {
        ...state,
        drivers: action.drivers,
      };

    case actions.GET_FINISHED_ORDERS_SUCCESS:
      return {
        ...state,
        finishedOrders: action.finishedOrders,
        finishedOrdersTotal: action.finishedOrdersTotal,
        finishedOrdersSummary: action.finishedOrdersSummary,
        finishedOrdersDrivers: action.finishedOrdersDrivers,
      };

    case actions.GET_FINISHED_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        modalOrder: action.modalOrder,
        showOrderInfoModal: action.showOrderInfoModal,
      };

    case actions.GET_TOP_CUSTOMERS_SUCCESS:
      return {
        ...state,
        topCustomers: action.topCustomers,
        topCustomersTotal: action.topCustomersTotal,
      };

    case actions.SET_ARCHIVE_LOADING:
      return {
        ...state,
        archiveLoading: action.value,
      };

    case actions.GET_ORDERS_SUCCESS:
      // var updateState = false;
      for (let colIndex = 0; colIndex < action.orders.length; colIndex++) {
        const colOrders = action.orders[colIndex];

        for (let index = 0; index < colOrders.length; index++) {
          if (
            !state.orders[colIndex]?.some((o) => o.id === colOrders[index].id)
          ) {
            // state.orders[colIndex].push(colOrders[index])
            // updateState = true;
          }
        }
      }
      //todo
      // if(updateState ){
      return {
        ...state,
        orders: action.orders,
      };
    // }
    // break;

    case actions.UPDATE_DRAG_AND_DROP:
      return {
        ...state,
        orders: action.orders,
      };

    case actions.TOGGLE_ORDER_INFO:
      return {
        ...state,
        showOrderInfoModal: !state.showOrderInfoModal,
        modalOrder: action.modalOrder,
      };

    case actions.UPDATE_ORDER_STATUS_SUCCESS:
      var index = 0;
      state.orders[action.order.status].forEach((orderItem, x) => {
        if (action.order.id === orderItem.id) index = x;
      });
      state.orders[action.order.status][index].status = action.order.status;
      return {
        ...state,
        orders: state.orders,
      };

    case actions.TOGGLE_NEW_ORDER_MODAL:
      return {
        ...state,
        showNewOrderModal: !state.showNewOrderModal,
        menuItems: !state.showNewOrderModal ? [] : state.menuItems,
        menuCategories: !state.showNewOrderModal ? [] : state.menuCategories,
        itemModifiers: !state.showNewOrderModal ? {} : state.itemModifiers,
        customerHistory: !state.showNewOrderModal ? null : state.customerHistory,
      };

    case actions.GET_MENU_ITEMS_SUCCESS:
      return {
        ...state,
        menuItems: action.menuItems,
      };

    case actions.GET_MENU_CATEGORIES_SUCCESS:
      return {
        ...state,
        menuCategories: action.menuCategories,
      };

    case actions.GET_ITEM_MODIFIERS_SUCCESS:
      return {
        ...state,
        itemModifiers: action.modifiers,
      };

    case actions.GET_CUSTOMER_HISTORY_SUCCESS:
      return {
        ...state,
        customerHistory: action.customerHistory,
      };

    case actions.CREATE_ORDER_BY_DISPATCHER_SUCCESS:
      return {
        ...state,
        showNewOrderModal: false,
        menuItems: [],
        itemModifiers: {},
      };

    default:
      return state;
  }
}
